import { render, staticRenderFns } from "./ServiceProviderRegion.vue?vue&type=template&id=30b522ee"
import script from "./ServiceProviderRegion.vue?vue&type=script&lang=js"
export * from "./ServiceProviderRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports